import React, { ReactNode, useState } from 'react';
import { useLoadedData } from '../../../toolympus/hooks/useLoadedData';
import { CaseRecord, CaseRecordApiPath, useCaseRecordSchema } from '../../CaseRecords/useCaseRecordsList';
import { DialogState, useThrottledCapture } from '../../../toolympus/components/primitives';
import { SelectItemDialog } from '../../../toolympus/components/primitives/SelectItemDialog';

const useCaseRecordSearch = () => {
  const [search,setSearch] = useState<string>("");
  const searchSubmitted = useThrottledCapture(search, 700);
  const data = useLoadedData<CaseRecord[]>(`${CaseRecordApiPath}?title_search=${searchSubmitted}`, [], !!searchSubmitted);

  const schema = useCaseRecordSchema();

  return {
    data,
    search,
    schema,
    isSubmitted: search === searchSubmitted,
    setSearch,
  }
}


interface Props extends Omit<DialogState, "open"> {
  title: ReactNode;
  isLoading?: boolean;
  selectRecord: (cr: CaseRecord) => void;
}

export const CaseRecordSelectionDialog = (props: Props) => {
  const data = useCaseRecordSearch();

  return (
    <SelectItemDialog
      available={data.data.data}
      close={() => props.close()}
      isOpen={props.isOpen}
      fields={[
        ["title"],
        ["case_type"],
        ["is_published"]
      ]}
      filter={data.search}
      setFilter={v => data.setSearch(v)}
      isLoading={data.data.isLoading}
      schema={data.schema}
      title={props.title}
      select={r => props.selectRecord(r)}
      />
  );
}
